import styled from 'styled-components';
import TextCSS from './Styles';

const Headline1 = styled.span`
  ${TextCSS.Headline1}
`;

const Headline2 = styled.span`
  ${TextCSS.Headline2}
`;

const Title1 = styled.span`
  ${TextCSS.Title1}
`;

const Title2 = styled.span`
  ${TextCSS.Title2}
`;

const Title3 = styled.span`
  ${TextCSS.Title3}
`;

const BodyB = styled.span`
  ${TextCSS.BodyB}
`;

const BodyM = styled.span`
  ${TextCSS.BodyM}
`;

const BodyR = styled.span`
  ${TextCSS.BodyR}
`;

const FootnoteB = styled.span`
  ${TextCSS.FootnoteB}
`;

const FootnoteM = styled.span`
  ${TextCSS.FootnoteM}
`;

const FootnoteR = styled.span`
  ${TextCSS.FootnoteR}
`;

const Caption1 = styled.span`
  ${TextCSS.Caption1}
`;

const TX = {
  Headline1,
  Headline2,
  Title1,
  Title2,
  Title3,
  BodyB,
  BodyM,
  BodyR,
  FootnoteB,
  FootnoteM,
  FootnoteR,
  Caption1,
};

export default TX;
